/**
 * @generated SignedSource<<25d7079479ad0af266b046dfc6fe9c7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DashboardFlightsCardTable_flightsInfo$data = {
  readonly failedFlights: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsTableRow_flight">;
  }>;
  readonly " $fragmentType": "DashboardFlightsCardTable_flightsInfo";
};
export type DashboardFlightsCardTable_flightsInfo$key = {
  readonly " $data"?: DashboardFlightsCardTable_flightsInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsCardTable_flightsInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardFlightsCardTable_flightsInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Flight",
      "kind": "LinkedField",
      "name": "failedFlights",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DashboardFlightsTableRow_flight"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DashboardFlightsInfo",
  "abstractKey": null
};

(node as any).hash = "c9e74d4cfdc6df97b2ff53df6cb1bd0c";

export default node;
